module.exports = __webpack_public_path__ + "img/4.dae3c2aa.png";